// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"InfoBox_infoBox__KQakZ"};